/* assets/src/viewer/models/support.js
 * Posizioni dei pilastri intermedi per campate larghe (port getStructuralSupportPositions :1191-1230).
 */
export function getStructuralSupportPositions(config = {}, widthMeters = 0) {
  const widthCm = parseInt(config.larghezza || Math.round(widthMeters * 100), 10) || 0;
  let moduleCount = 0;

  const quoteModules = (config.__quote && Array.isArray(config.__quote.modulesApplied))
    ? config.__quote.modulesApplied
    : (window.ASG_CurrentQuote && Array.isArray(window.ASG_CurrentQuote.modulesApplied) ? window.ASG_CurrentQuote.modulesApplied : []);

  if (quoteModules.length) {
    moduleCount = quoteModules.filter((item) => item && (parseInt(item.threshold || 0, 10) || 0) > 0).length;
  } else if (window.ASG_Data && window.ASG_Data.models && config.modelId && window.ASG_Data.models[config.modelId]) {
    try {
      const raw = window.ASG_Data.models[config.modelId].modulesJSON || '[]';
      const modules = JSON.parse(raw);
      if (Array.isArray(modules)) {
        moduleCount = modules.filter((module) => {
          if (!module || typeof module !== 'object') return false;
          const threshold = parseInt(String(module.threshold ?? module.min_width ?? module.larghezza ?? '').replace(/[^\d]/g, ''), 10) || 0;
          return threshold > 0 && widthCm >= threshold;
        }).length;
      }
    } catch (err) {
      moduleCount = 0;
    }
  }

  if (moduleCount === 0 && (!config.modelId || !window.ASG_Data || !window.ASG_Data.models || !window.ASG_Data.models[config.modelId])) {
    if (widthMeters > 9.0) moduleCount = 2;
    else if (widthMeters > 5.0) moduleCount = 1;
  }

  const segmentCount = Math.max(1, 1 + moduleCount);
  if (segmentCount <= 1) return [];

  const positions = [];
  for (let index = 1; index < segmentCount; index++) {
    positions.push((-widthMeters / 2) + (widthMeters * index / segmentCount));
  }
  return positions;
}
